/* 지시문. 식 문법은 정본 data/dsl/dsl.json 의 exprGrammar 에서 조립한다 */
import { DSL, stripSources } from './tools';

interface ExprGrammar {
  commands: string[];
  functions: string[];
  relations: string[];
  keywords: string[];
  categories: string[];
  conditionList?: { open: string; separator: string; close: string; relations: string[] };
  definiteIntegral?: string;
  derivative?: string;
  absolute?: string;
}

function grammarText(): string {
  const g = (DSL as unknown as { exprGrammar: ExprGrammar }).exprGrammar;
  return [
    `역슬래시 명령(이 밖의 \\명령은 없다): ${g.commands.map((c) => `\\${c}`).join(' ')}.`,
    `파서가 이름으로 아는 함수: ${g.functions.join(' ')}.`,
    `관계: ${g.relations.join(' ')}. 논리어: ${g.keywords.join(' ')}.`,
    `꼴: ${g.categories.filter((c) => c !== 'EMPTY' && c !== 'INVALID').join(' ')} — y=f(x) · f(x)=… · x^{2}+y^{2}=4 꼴. a=3 은 매개변수 정의.`,
    g.conditionList
      ? `정의역·조건: 제한이 필요할 때만 식 바로 뒤에 ${g.conditionList.open}조건${g.conditionList.separator} 조건${g.conditionList.close} — 예 y=x^{2}{0<x<4}, y=\\sqrt{x}{0 \\le x \\le 4}. 조건 안 관계는 ${g.conditionList.relations.join(' ')} 와 \\le \\ge 뿐이다. \\infty 는 못 읽는다. 제한이 없으면 아무것도 붙이지 않는다.`
      : '',
    g.definiteIntegral ? `정적분: ${g.definiteIntegral} — dx 가 아니라 \\differentialD x 다.` : '',
    g.derivative ? `미분: ${g.derivative}.` : '',
    g.absolute ? `절댓값: ${g.absolute}.` : '',
    '지수는 3^{x}, 분수는 \\frac{1}{2}x, 로그는 \\log_{3}(x+3) 처럼 쓴다. 숫자를 중괄호로 감싸지 않는다({0.5} 금지). 소수로 근사하지 말고 식 그대로 쓴다.',
    '위에 없는 것(\\quad·\\text·\\lim·\\sum·괄호 설명·한글·단위)은 식에 넣지 않는다. 계산한 값은 그림에 싣지 않고 답변에 쓴다.',
    '문항이 쓴 기호(\\alpha, \\theta, a_1 같은 것)는 식에 문항의 표기 그대로 쓰고 값은 values(symbols)에 준다. 값 없는 기호가 식에 남으면 그 식은 반려된다.',
  ].filter(Boolean).join(' ');
}

/** 식을 쓰는 단계(풀이, 도구 선택)에 주는 정본 식 문법과 algebraric 의 인자 범위. 출처 꼬리표는 모델에게 주지 않는다 */
export function exprGrammarRule(): string {
  const entry = (DSL as unknown as { entries: { tool: string; name: string; range?: string[] }[] }).entries.find((e) => e.tool === 'math2d' && e.name === 'algebraric');
  const range = (entry?.range ?? []).map(stripSources).filter(Boolean);
  return [
    '## 식 문법 (mathcore 정본 파서. 식은 이 문법으로만 쓴다. 어기면 엔진이 식을 무효로 버린다)',
    grammarText(),
    range.length ? `## algebraric 인자 범위 (정본 dsl.json)\n${range.map((r) => `- ${r}`).join('\n')}` : '',
  ].filter(Boolean).join('\n');
}
